import React, { useState } from 'react';
import ScreenplayAdmin from './ScreenplayAdmin';
import MusicAnalyzerAdmin from './MusicAnalyzerAdmin';

export default function StudioAdmin({ adminToken }) {
  const [tab, setTab] = useState('screenplay');

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8 space-y-6">
      <div className="flex gap-2 p-1 bg-black/40 rounded-lg w-fit">
        <button
          onClick={() => setTab('screenplay')}
          className={`px-5 py-2.5 rounded-md text-sm font-semibold transition-all ${
            tab === 'screenplay' ? 'bg-emerald-500 text-black' : 'text-white/70 hover:text-white'
          }`}
        >
          🎬 Drehbuch generieren
        </button>
        <button
          onClick={() => setTab('music')}
          className={`px-5 py-2.5 rounded-md text-sm font-semibold transition-all ${
            tab === 'music' ? 'bg-emerald-500 text-black' : 'text-white/70 hover:text-white'
          }`}
        >
          🎵 Musik & Suno-Prompts
        </button>
      </div>

      {tab === 'screenplay' && <ScreenplayAdmin adminToken={adminToken} />}
      {tab === 'music' && <MusicAnalyzerAdmin adminToken={adminToken} />}
    </div>
  );
}
